import $ from 'jquery';

$(function () {
  $('form.js-form-with-helper-texts .form-control').on('focusin', function () {
    var helperTexts = $('.js-helper-text');
    var helperText = $(this.parentElement).find('.js-helper-text');
    helperTexts.addClass('hidden');
    helperText.removeClass('hidden');
  });

  $('.js-help').click(function () {
    var textSelector = $(this).data('textSelector');
    if (!textSelector) {
      return;
    }
    $(textSelector).toggleClass('hidden');
  });
});
